$(function () {
	if ($('#uber').hasClass('interior')) {
		// Add class to uber if calendar template
		if ($('#CalendarTemplate').length > 0) {
			$('#uber').addClass('calendarView');
		}
	}
});
/*==========================================================
Moving sidebar elements when in mobile
==========================================================*/
function mobileMove() {
	if (Modernizr.mq('(max-width: 991px)')) {
		if ( $('#contactMainContainer').length ) {
			$('#contactMainContainer').detach().appendTo('#printAreaContent');
		}
		if ( $('#pageSubscription').length ) {
			$('#pageSubscription').detach().appendTo('#printAreaContent');
		}
	} else if (Modernizr.mq('(min-width: 992px)')) {
		if ( $('#contactMainContainer').length ) {
			$('#contactMainContainer').detach().appendTo('#subNavWrapper');
		}
		if ( $('#pageSubscription').length ) {
			$('#pageSubscription').detach().appendTo('#subNavWrapper');
		}
	}
}
/*==========================================================
SCHEDULE TABLE FIXED HEADER SETUP && TABLE RESIZE - IF TABLE CANNOT FIT INSIDE CONTAINER
==========================================================*/
function icrt_table_resize() {
	if (!iCreateObject.isSiteInICreateMode || iCreateObject.isSiteInPreviewMode) {
		var contentWidth = ($('#printAreaContent').width());

		$('#printAreaContent .datatable').each(function (index, item) {
			var contentRow = $(item).closest('.fbg-row');

			if ((contentRow.length && $(this).width() > $(contentRow).width()) || $(this).width() > contentWidth) {
				if ($(this).parent('.tableContainer').length == 0) {
					$(this).wrap('<div class="tableContainer" />');
					var wideTable = $(this).addClass('wideTable');
					var wideTableContainer = $(wideTable).parent();
					var tableScrollMessage;

					if ((typeof iCreateObject === "undefined" || iCreateObject === null) || (typeof iCreateObject.languageResources === "undefined" || iCreateObject.languageResources === null) || (typeof iCreateObject.languageResources.Common_Includes_headInterior_TableScrollMessage === "undefined" || iCreateObject.languageResources.Common_Includes_headInterior_TableScrollMessage === null)) {
						tableScrollMessage = "Scroll right to view complete table";
					} else {
						tableScrollMessage = iCreateObject.languageResources.Common_Includes_headInterior_TableScrollMessage;
					}

					$('<div class="tableContainerHead">' + tableScrollMessage + '</div>"').insertBefore(wideTableContainer);

					if ($(this).parent('.scheduleTableWrapper').length == 0 && $(this).hasClass('scheduleTable')) {
						$(this).parent().addClass('scheduleTableWrapper');
					}

				}
			} else if ((contentRow.length && $(this).width() <= $(contentRow).width()) || $(this).width() <= contentWidth) {
				if ($(this).parent('.tableContainer').length > 0) {
					$(this).parent().siblings('.tableContainerHead').detach();
					$(this).unwrap();
					$(this).removeClass('wideTable');
				}
			}
		});

	}
}

$(window).load(function () {
	setTimeout(function () {
		icrt_table_resize();
		mobileMove();
	}, 0);
});

$(window).resize(function () {
	setTimeout(function () {
		icrt_table_resize();
		mobileMove();
	}, 0);
});